import { inject } from '@angular/core';
import { type CanMatchFn } from '@angular/router';
import { CoreService } from '../services/core.service';

/**
 * Prevents routes from matching when the app is in maintenance mode.
 * The maintenance UI is handled at the app root level (app.html),
 * so no routes should activate during maintenance.
 */
export const notMaintenanceGuard: CanMatchFn = () => {
  const coreService = inject(CoreService);
  const appConfig = coreService.appConfig();

  // Block route matching if app is under maintenance
  return !appConfig?.maintenance?.partner;
};
